module.exports = __webpack_public_path__ + "img/swiper1_t.00113197.png";